<template>
    <div class="mb-4">
        <h5>{{ $t('Registered registerAddress') }}</h5>
        <div class="px-0 mb-3 mt-3">
            
            <b-row class="mb-3">
                <b-col cols="12" md="4">
                    <div class="form-group mb-0 p-2">
                        <label>{{ $t('Registered Address (Country)') }} <span class="text-danger">*</span></label>
                        <Select2 v-model="registerCountry" :options="countryOpt" @select="onSelectCountry($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Country")}' class="form-control"/>
                        <div v-if="error['registerCountry']" class="invalid-feedback d-block mb-3">
                        {{$t(error['registerCountry'])}}
                        </div>
                    </div>
                </b-col>

                <b-col cols="12" md="4">
                    <div class="form-group mb-0 p-2">
                    <label>{{ $t('Registered Address (Province)') }} <span class="text-danger">*</span></label>
                    <Select2 v-model="params.registerProvince" :options="stateOpt" @select="onSelectState($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("State")}' class="form-control"/>
                    <div v-if="error['registerProvince']" class="invalid-feedback d-block mb-3">
                        {{$t(error['registerProvince'])}}
                    </div>
                    </div>
                </b-col>
                <b-col cols="12" md="4">
                    <div class="form-group mb-0">
                        <label>{{ $t('Registered Address (City)') }} <span class="text-danger">*</span></label>
                        <input type="text" maxlength="58" v-model="params.registerCity" name="registerCity" value="" :placeholder="$t('City')" class="form-control" @keydown="onChange('registerCity')" autocomplete=off>
                        <div v-if="error['registerCity']" class="invalid-feedback d-block mb-3">
                            {{$t(error['registerCity'])}}
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-5">
                <b-col cols="12">
                    <div class="form-group mb-0">
                        <label>{{ $t('Registered Address (Full Address)') }} <span class="text-danger">*</span></label>
                        <input type="text" name="registerAddress" v-model="params.registerAddress" class="form-control" @keydown="registerAddressCondition($event)" @keyup="onchangeregisterAddress($event)"/>
                        <div v-if="error['registerAddress']" class="invalid-feedback d-block mb-3">
                            {{$t(error['registerAddress'])}}
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
        
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Select2 from 'v-select2-component';

import NewDocOption from "@/components/Kyc/NewDocOption";
import FileUploader from '@/components/Kyc/FileUploader.vue';
import NewPopupInfo from '@/components/NewPopupInfo.vue';
import CreateAccount from '@/services/CreateAccount';
import Common from '@/services/Common';

import 'vue2-datepicker/locale/zh-cn';
import 'vue2-datepicker/locale/zh-tw';
import 'vue2-datepicker/locale/ja';
import 'vue2-datepicker/locale/en';

export default {
  data() {
    return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        maxSize:4,
        countryOpt:[],
        stateOpt:[],
        registerCountry:'',
        showPopup:false,
        lang_date:'en',
        success:null,
        params:{
            registerCountry:'',
            registerProvince:'',
            registerCity:'',
            registerAddress:''
        },
        error:{
            registerCountry:'',
            registerProvince:'',
            registerCity:'',
            registerAddress:''
        },
        optional:[]
    }
  },
  components:{
    NewDocOption,
    FileUploader,
    Select2,
    NewPopupInfo,
    DatePicker
  },
  methods:{
    geetAccountList(){
        let self = this;
        CreateAccount.list({
            search:self.search,
            start:0,
            length:-1
        }).then((response)=>{
            if (response.status == 200) {
                self.formData = response.data.data[0]['information'];

                Object.keys(this.params).forEach(function(key) {
                    self.params[key]=self.formData[key];
                });

                // set country
                for (let i = 0; i < this.countryOpt.length; i++) {
                    if(self.countryOpt[i]['iso3'] == self.params.registerCountry){
                        self.registerCountry = self.countryOpt[i]['id'];
                        break;
                    }
                }

                Common.states({"state_name":self.params['registerProvince']}).then(response => {
                    if(response.status == 200 && response.data.success){
                        const province = response.data.data;
                        for (let i = 0; i < province.length; i++) {
                            self.stateOpt.push({"id":province[i]['name'],"text":province[i]['name']});
                        }
                    }
                });
            }
        });
    },
    registerAddressCondition($event){
        if($event.keyCode == 13){
            $event.preventDefault();
        }
        this.onChange('registerAddress');
    },
    onchangeregisterAddress($event){
        let msg = $event.target.value.replace("\n", " ");
        $event.target.value = msg;
    },
    onSelectCountry({id,text,iso3}){
        var self = this;
        this.onChange('registerCountry');
        self.stateOpt = [];
        if(text){
            this.params.registerCountry = iso3;
            this.params.registerProvince="";
            this.params.registerCity="";
        }
        
        Common.states({"registerCountry":id}).then(response => {
            if(response.status == 200 && response.data.success){
                const state = response.data.data;
                for (let i = 0; i < state.length; i++) {
                self.stateOpt.push({"id":state[i]['name'],"text":state[i]['name']});
                }
            }
        });
    },
    onSelectState({id,text}){
        var self = this;
        this.onChange('registerProvince');
    },
    validate(){
        let success = true;
        let self = this;
        Object.keys(this.params).forEach(function(key) {
            if(!self.params[key] && !self.optional.includes(key)){
                console.log(key+" can not blank");
                self.error[key]="can not be blank.";
                success = false;
            }
        });

        return success;
    },
    checkError(err){
        try{
            let self = this;
            const response = err.response;  
            if(response.status == 400){
                if(typeof response.data.message === 'string'){
                    this.$notify({
                        type: 'warn',
                        text: response.data.message
                    });
                }
                else{
                    if(response.data.message['file']){
                        let fileList = response.data.message['file'];
                        for(let i=0;i<fileList.length;i++){
                            if(fileList[i].type==7){
                                self.error.license=fileList[i].message;
                            }
                        }
                    }
                    self.success = false;
                    self.$emit('file-uploaded');
                }
            }      
            else if(response.status == 401 && response.data.name == "Unauthorized"){
                    localStorage.removeItem("token");
                    localStorage.removeItem("member");
                    localStorage.removeItem("isFirstTime");
                    this.$router.push({ 
                        path: '/login', 
                    });
            }
            else{
                if(localStorage.getItem("token")){
                    var msg = (response.data)?response.data.message:err.message;
                    this.$notify({
                        type: 'warn',
                        text: msg
                    })
                }
            }
        }catch(e){
            console.log(err);
        }
    },
    onChange(name){
        this.error[name]="";
    },
    togglePopup(){
        this.showPopup=!this.showPopup;
    },
    doEscapeMarkup(markup){
        return markup;
    }
  },
    mounted(){
        let self = this;
        Common.countries().then(response => {
          if(response.status == 200 && response.data.success){
            const countries=response.data.data;
  
            for (let i = 0; i < countries.length; i++) {
              const flag = '<span class="fi fi-'+countries[i]['iso2'].toLowerCase()+'"></span>';  
              const country_name = "<span>"+this.$t(countries[i]['name'])+"\t\t\t"+"</span>";
              
              self.countryOpt.push({"id":countries[i]['iso2'],"text":flag+country_name,"iso3":countries[i]['iso3']});
            }

            self.geetAccountList();
          }
        });
    }
}
</script>